import React, { useState } from 'react';
import { Button } from '@sumologic/yama-ds-components';

import Translate from '~/components/Translate/Translate';
import MiniModal from '~/components/MiniModal/MiniModal';

import OperatorsHelperText from './OperatorsHelperText/OperatorsHelperText';

const commands = [
    {
        key: '+',
        testId: 'or',
        display: 'OR',
        description: 'OR operator'
    },
    {
        key: ',',
        testId: 'and',
        display: 'AND',
        description: 'AND operator'
    },
    {
        key: '>',
        testId: 'greater-than',
        description: 'Greater than'
    },
    {
        key: '<',
        testId: 'less-than',
        description: 'Less than'
    },
    {
        key: '>=',
        testId: 'greater-or-equal-to',
        description: 'Greater or equal to'
    },
    {
        key: '<=',
        testId: 'less-or-equal-to',
        description: 'Less or equal to'
    },
    {
        key: '!=',
        testId: 'not-equal-to',
        description: 'Not equal to'
    },
    {
        key: '=',
        testId: 'equal-to',
        description: 'Equal to'
    }
].map(item => {
    item.display = `${item.display || item.key}\u0020`;
    return item;
});

const OperatorsHelper = ({ show, onHide, inputChangeHandler }) => {
    const [expanded, setExpanded] = React.useState(false);
    return (
        <MiniModal
            show={show}
            bodyClassName="operators-helper"
            title={<Translate message="Operators Helper" />}
            posY="40px"
            posX="-29px"
            width={expanded ? '750px' : '250px'}
            onHide={onHide}
        >
            <div
                className="d-flex justify-content-start overflow-hidden"
                id="operators-helper"
            >
                <div
                    className="mt-2"
                    data-testid="operators-list"
                    style={{ minWidth: '250px' }}
                >
                    {commands.map((item, index) => {
                        return (
                            <div
                                key={index}
                                data-testid={`operator_${item.testId}`}
                                className="d-flex align-items-center my-1 py-1 px-3 minimodal-item"
                                onClick={() => {
                                    inputChangeHandler(item);
                                    onHide();
                                }}
                            >
                                <Button
                                    size="small"
                                    className="me-1 operators-helper__button"
                                    variant="contained"
                                    color="primary"
                                >
                                    <strong>{item.key}</strong>
                                </Button>
                                <span className="ms-4">
                                    <Translate message={item.description} />
                                </span>
                            </div>
                        );
                    })}
                    <span
                        data-testid="toggle-operators-helper__manual"
                        className="d-flex align-items-center mt-3 mb-2 py-1 px-3 minimodal-item"
                        onClick={() => setExpanded(oldExpanded => !oldExpanded)}
                    >
                        <Translate
                            message={expanded ? 'Show less...' : 'Show more...'}
                        />
                    </span>
                </div>
                <div className="d-flex pt-3 py-1 px-3 minimodal-text operators-helper__manual">
                    <OperatorsHelperText />
                </div>
            </div>
        </MiniModal>
    );
};

export default OperatorsHelper;
